import "./industries.css";
import SEO from "../../SEO";
import useReveal from "../../hooks/useReveal";

/* ── SVG icons ─────────────────────────────────────────────────────────── */
const BankIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
  </svg>
);

const GatewayIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="1" y="4" width="22" height="16" rx="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);

const ShieldIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const ChartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="2" y1="20" x2="22" y2="20" />
  </svg>
);

const LoanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const LockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const BrainIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);

const CloudIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Data ───────────────────────────────────────────────────────────────── */
const solutions = [
  {
    icon: <BankIcon />,
    title: "Digital Banking Applications",
    tag: "Core Banking",
    desc: "Full-featured digital banking with user accounts, transaction history, multi-currency support, and seamless payment integrations.",
  },
  {
    icon: <GatewayIcon />,
    title: "Payment Gateway Systems",
    tag: "Payments",
    desc: "Secure payment processing infrastructure with real-time settlement, multi-method support, and enterprise-grade reliability.",
  },
  {
    icon: <ShieldIcon />,
    title: "Fraud Detection Systems (AI-Based)",
    tag: "AI Security",
    desc: "ML models that flag suspicious transactions in real-time — trained on behavioral patterns, device fingerprints, and velocity signals.",
  },
  {
    icon: <ChartIcon />,
    title: "Financial Analytics Dashboards",
    tag: "Business Intel",
    desc: "Real-time revenue, expense, and forecasting dashboards with drill-down capability — turning raw data into clear strategic insights.",
  },
  {
    icon: <LoanIcon />,
    title: "Loan & Credit Management Systems",
    tag: "Lending Tech",
    desc: "End-to-end loan origination, approval workflows, credit scoring, and repayment tracking for banks, NBFCs, and fintech lenders.",
  },
];

const projects = [
  {
    icon: <ShieldIcon />,
    tag: "AI · Fraud Detection",
    title: "AI Fraud Detection System",
    desc: "Detect suspicious transactions in milliseconds using ML models trained on behavioral patterns, device fingerprints, and transaction velocity signals.",
    features: [
      "Real-time risk scoring per transaction",
      "Behavioral anomaly detection engine",
      "Auto-block & instant alert workflows",
    ],
  },
  {
    icon: <ChartIcon />,
    tag: "Analytics · Dashboard",
    title: "Finance Analytics Dashboard",
    desc: "A real-time financial intelligence platform with live revenue tracking, expense categorisation, and AI-driven forecasting modules for enterprise teams.",
    features: [
      "Live P&L and cash flow visualization",
      "Predictive revenue forecasting",
      "Multi-entity consolidated reporting",
    ],
  },
  {
    icon: <BankIcon />,
    tag: "Banking · Platform",
    title: "Digital Banking Platform",
    desc: "A full-stack digital banking solution covering KYC onboarding, account management, fund transfers, and multi-channel payment gateway integrations.",
    features: [
      "Digital KYC & onboarding flows",
      "Multi-channel payment integrations",
      "Role-based access & full audit logs",
    ],
  },
];

const benefits = [
  {
    icon: <LockIcon />,
    title: "High Security & Compliance",
    desc: "Encryption at rest and in transit, role-based access control, and immutable audit trails — built to the controls RBI, PCI-DSS, and SOC 2 audits look for.",
  },
  {
    icon: <ClockIcon />,
    title: "Real-Time Transaction Monitoring",
    desc: "Event-streaming pipelines score every transaction as it happens, so suspicious activity surfaces while it can still be stopped.",
  },
  {
    icon: <BrainIcon />,
    title: "Smart Financial Insights",
    desc: "Forecasting and anomaly models that surface trends, leakage, and risk concentrations hidden in raw ledger data.",
  },
  {
    icon: <CloudIcon />,
    title: "Scalable Cloud Infrastructure",
    desc: "Auto-scaling AWS architecture with multi-AZ redundancy, sized to carry peak transaction volume without manual intervention.",
  },
];

/* ── Component ──────────────────────────────────────────────────────────── */
export default function Finance() {
  const [solRef, solVisible] = useReveal();
  const [projRef, projVisible] = useReveal();
  const [benRef, benVisible] = useReveal();

  return (
    <>
      <SEO
        title="FinTech: AI for Finance & Fraud Detection | Best Code Technology"
        description="AI-powered finance solutions including fraud detection and analytics platforms."
        keywords="finance AI, fintech solutions, fraud detection"
        url="https://bestcodetechnology.in/industries/finance"
      />
      <div className="ind-page ind-page--finance">
        {/* ════════════════════════════════════════════════════════════════════
          HERO — split layout: left content, right dashboard mockup
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-hero">
          <div className="container-xl">
            <div className="row align-items-center g-5">
              {/* Left: Content */}
              <div className="col-12 col-lg-6">
                <div className="fin-hero__eyebrow">
                  <div className="fin-hero__icon-wrap" aria-hidden="true">
                    <BankIcon />
                  </div>
                  <span className="pill-label">Finance Industry</span>
                </div>

                <h1 className="fin-hero__headline">
                  Secure, Intelligent &amp;
                  <br />
                  <span>Scalable Financial</span>
                  <br />
                  Solutions
                </h1>

                <p className="fin-hero__desc">
                  We build advanced financial systems with strong security,
                  real-time processing, and AI-driven insights — engineered for
                  banks, NBFCs, fintechs, and enterprise finance teams.
                </p>

                <div className="fin-hero__actions">
                  <a href="#solutions" className="fin-btn-primary">
                    Explore Solutions
                    <ArrowIcon />
                  </a>
                  <a href="#projects" className="fin-btn-ghost">
                    See What We Build
                  </a>
                </div>

                <div className="fin-hero__stats">
                  <div className="fin-stat">
                    <span className="fin-stat__value">Multi-AZ</span>
                    <span className="fin-stat__label">High Availability</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">Real-Time</span>
                    <span className="fin-stat__label">Transaction Scoring</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">AI-First</span>
                    <span className="fin-stat__label">Fraud Detection</span>
                  </div>
                  <div className="fin-stat__sep" aria-hidden="true" />
                  <div className="fin-stat">
                    <span className="fin-stat__value">PCI-DSS</span>
                    <span className="fin-stat__label">Aligned Controls</span>
                  </div>
                </div>
              </div>

              {/* Right: Dashboard Mockup */}
              <div className="col-12 col-lg-6">
                <div className="fin-dashboard">
                  {/* Top bar */}
                  <div className="fin-dashboard__bar">
                    <div className="fin-dashboard__title">
                      <div className="fin-dashboard__dot" aria-hidden="true" />
                      Finance Dashboard
                    </div>
                    <span className="fin-dashboard__live">● Live</span>
                  </div>

                  <div className="fin-dashboard__body">
                    {/* KPI row */}
                    <div className="fin-kpi-row">
                      <div className="fin-kpi">
                        <p className="fin-kpi__label">Total Revenue</p>
                        <p className="fin-kpi__value">₹2,48,520</p>
                        <span className="fin-kpi__trend fin-kpi__trend--up">
                          ↑ +12.4% this month
                        </span>
                      </div>
                      <div className="fin-kpi">
                        <p className="fin-kpi__label">Risk Score Avg</p>
                        <p className="fin-kpi__value">0.07</p>
                        <span className="fin-kpi__trend fin-kpi__trend--down">
                          ↓ Low risk level
                        </span>
                      </div>
                    </div>

                    {/* Bar chart */}
                    <div className="fin-chart">
                      <div className="fin-chart__header">
                        <span className="fin-chart__label">
                          Monthly Transaction Volume
                        </span>
                        <span className="fin-chart__tag">+18% YoY</span>
                      </div>
                      <div className="fin-bars" aria-hidden="true">
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                        <div className="fin-bar" />
                      </div>
                    </div>

                    {/* Transaction feed */}
                    <div className="fin-feed">
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--success"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Payment Verified
                          </span>
                          <span className="fin-feed__sub">
                            HDFC Bank · 2s ago
                          </span>
                        </div>
                        <span className="fin-feed__amount fin-feed__amount--credit">
                          +₹18,400
                        </span>
                      </div>
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--alert"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Fraud Alert Blocked
                          </span>
                          <span className="fin-feed__sub">
                            ML Model · Flagged
                          </span>
                        </div>
                        <span className="fin-feed__amount fin-feed__amount--debit">
                          -₹52,000
                        </span>
                      </div>
                      <div className="fin-feed__row">
                        <div
                          className="fin-feed__icon fin-feed__icon--success"
                          aria-hidden="true"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </div>
                        <div>
                          <span className="fin-feed__text">
                            Settlement Completed
                          </span>
                          <span className="fin-feed__sub">NEFT · Batch 14</span>
                        </div>
                        <span className="fin-feed__amount fin-feed__amount--credit">
                          +₹3,24,800
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          SOLUTIONS — horizontal feature rows
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-solutions" id="solutions">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="pill-label">Key Solutions</span>
                <h2 className="ind-section-title mt-3">
                  Financial Systems Built for Scale &amp; Trust
                </h2>
                <p className="ind-section-sub">
                  Five core product lines covering every critical layer of
                  modern financial infrastructure — from customer-facing banking
                  apps to backend risk and analytics engines.
                </p>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="fin-sol-list reveal-stagger" ref={solRef}>
                  {solutions.map((item, i) => (
                    <div
                      key={item.title}
                      className={`fin-sol-row reveal reveal--left ${solVisible ? "" : "is-hidden"}`}
                      style={{ "--stagger-index": i }}
                    >
                      <div className="fin-sol-row__icon">{item.icon}</div>
                      <div className="fin-sol-row__content">
                        <h4 className="fin-sol-row__title">{item.title}</h4>
                        <p className="fin-sol-row__desc">{item.desc}</p>
                      </div>
                      <span className="fin-sol-row__tag">{item.tag}</span>
                      <span className="fin-sol-row__arrow">
                        <ArrowIcon />
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Side callout card */}
              <div className="col-12 col-lg-4">
                <div className="fin-callout">
                  <div className="fin-callout__icon" aria-hidden="true">
                    <ShieldIcon />
                  </div>
                  <h3 className="fin-callout__title">
                    Built for Regulated Environments
                  </h3>
                  <p className="fin-callout__desc">
                    Every system we build is designed with compliance baked in —
                    not bolted on. RBI guidelines, PCI-DSS, and SOC 2
                    requirements are addressed at architecture level, not
                    afterthought.
                  </p>
                  <ul className="fin-callout__list">
                    <li>
                      <CheckIcon />
                      <span>End-to-end data encryption</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>Tamper-proof audit trails</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>Role-based access control</span>
                    </li>
                    <li>
                      <CheckIcon />
                      <span>Regulatory reporting ready</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          TECHNOLOGIES — 2×2 category cards
      ═══════════════════════════════════════════════════════════════════════ */}

        {/* ════════════════════════════════════════════════════════════════════
          PROJECTS — showcase cards with dark preview header
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-projects" id="projects">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="pill-label">Platform Capabilities</span>
                <h2 className="ind-section-title mt-3">
                  What We Build for Financial Services
                </h2>
                <p className="ind-section-sub">
                  Three platform builds we take on for finance teams — spanning
                  fraud detection, analytics, and digital banking.
                </p>
              </div>
            </div>

            <div className="row g-4 reveal-stagger" ref={projRef}>
              {projects.map((project, i) => (
                <div
                  key={project.title}
                  className={`col-12 col-lg-4 reveal ${projVisible ? "" : "is-hidden"}`}
                  style={{ "--stagger-index": i }}
                >
                  <div className="fin-project-card">
                    {/* Visual header */}
                    <div className="fin-project-card__preview">
                      <div className="fin-project-card__preview-icon">
                        {project.icon}
                      </div>
                    </div>
                    {/* Body */}
                    <div className="fin-project-card__body">
                      <span className="fin-project-card__tag">
                        {project.tag}
                      </span>
                      <h3 className="fin-project-card__title">
                        {project.title}
                      </h3>
                      <p className="fin-project-card__desc">{project.desc}</p>
                      <ul className="fin-project-card__features">
                        {project.features.map((feat, fi) => (
                          <li key={fi}>
                            <CheckIcon />
                            <span>{feat}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          BENEFITS — dark split: left headline+CTA, right benefit list
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="fin-benefits">
          <div className="container-xl">
            <div className="row align-items-center g-5 g-lg-8">
              {/* Left */}
              <div className="col-12 col-lg-5">
                <span className="ind-pill-dark">Why BCT</span>
                <h2 className="fin-benefits__headline mt-4">
                  The Advantage of
                  <br />
                  <span>Building with BCT</span>
                </h2>
                <p className="fin-benefits__sub">
                  From security architecture to AI-powered intelligence, every
                  system we build is engineered to perform under the strictest
                  financial compliance requirements.
                </p>
                <a href="/services/ai-applications" className="fin-btn-primary">
                  Start a Project
                  <ArrowIcon />
                </a>
              </div>

              {/* Right */}
              <div className="col-12 col-lg-7">
                <div className="fin-benefit-list reveal-stagger" ref={benRef}>
                  {benefits.map((b, i) => (
                    <div
                      key={b.title}
                      className={`fin-benefit-item reveal reveal--right ${benVisible ? "" : "is-hidden"}`}
                      style={{ "--stagger-index": i }}
                    >
                      <div className="fin-benefit-item__icon">{b.icon}</div>
                      <div>
                        <h4 className="fin-benefit-item__title">{b.title}</h4>
                        <p className="fin-benefit-item__desc">{b.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
